/**
 * Fenstertitel mit Ungelesen-Stand (D35): „(3) Lagerfeuer“ bei Erwähnungen/ungelesenen DMs, „• Lagerfeuer“ bei sonst
 * Ungelesenem – dasselbe Format wie der Discord-Webclient. Lagerfeuer Desktop liest daraus den Zähler für Leiste,
 * Taskleiste und Tray (ohne Preload in der Lagerfeuer-Ansicht); im Browser-Tab ist es dieselbe Anzeige.
 * Seiten mit eigenem Titel (Einstellungen) setzen nur den Grundtitel, der Ungelesen-Stand bleibt davor.
 */
import { useEffect } from 'react';

export const APP_TITLE = 'Lagerfeuer';

export interface UnreadSummary {
  unread: boolean;
  mentions: number;
}

let baseTitle = APP_TITLE;
let summary: UnreadSummary = { unread: false, mentions: 0 };

export function formatTitle(base: string, s: UnreadSummary): string {
  if (s.mentions > 0) return `(${s.mentions}) ${base}`;
  if (s.unread) return `• ${base}`;
  return base;
}

function apply(): void {
  if (typeof document === 'undefined') return;
  const next = formatTitle(baseTitle, summary);
  if (document.title !== next) document.title = next;
}

/** Ungelesen-Stand übernehmen (aus dem App-Store, siehe main.tsx). */
export function setUnreadSummary(next: UnreadSummary): void {
  if (next.unread === summary.unread && next.mentions === summary.mentions) return;
  summary = { unread: next.unread, mentions: next.mentions };
  apply();
}

/** Grundtitel setzen; null = „Lagerfeuer“. */
export function setBaseTitle(title: string | null): void {
  baseTitle = title || APP_TITLE;
  apply();
}

/** Grundtitel für die Lebensdauer einer Seite (danach wieder „Lagerfeuer“). */
export function useDocumentTitle(title: string | null): void {
  useEffect(() => {
    setBaseTitle(title);
    return () => setBaseTitle(null);
  }, [title]);
}
